import React, { FC } from 'react';
import styled from 'styled-components';
import { CourseViewType } from 'src/state/courseListing/courseListingReducer';
import { courseListingActions } from 'src/state/courseListing/courseListingActions';
import { useDispatch } from 'react-redux';
import { CleanButton } from 'src/common/components/Button';
import { typography } from 'src/config/typography';
import { colors } from 'src/config/colors';
import ChevronIcon from 'src/assets/icons/ChevronIcon';

const ShowAllItemsButton = styled(CleanButton)`
  font-family: ${typography.fontFamilyDefault};
  font-size: 0.75rem;
  line-height: 1rem;
  text-decoration-line: underline;
  color: ${colors.blue};
  opacity: 0.7;
  margin-top: 2.5rem;
`;

export interface CourseListingShowMoreButtonProps {
  courseViewType: CourseViewType.Online | CourseViewType.Elearning | CourseViewType.CourseBundle;
}

export const CourseListingShowMoreButton: FC<CourseListingShowMoreButtonProps> = ({
  courseViewType,
}) => {
  const dispatch = useDispatch();

  const handleShowAllItemsClick = () => {
    dispatch(courseListingActions.toggleCourseTypeView(courseViewType));
    window?.scrollTo({
      behavior: 'smooth',
      left: 0,
      top: 0,
    });
  };

  return (
    <ShowAllItemsButton onClick={handleShowAllItemsClick}>
      Zobacz wszystkie szkolenia{' '}
      <ChevronIcon style={{ marginLeft: '10px' }} direction="down" size={8} />
    </ShowAllItemsButton>
  );
};
